import styled from 'styled-components';
import { LinkId } from '../../../AnalyticsContext/LinkId';
import { PAGE_CONTAINER } from '../../../styles/Layout';
import { ThemeColours } from '../../../styles/ThemeColours';
import {
  Breakpoint,
  FontSize,
  LineHeight,
  FontWeight,
  PRESSABLE_LINK,
  STANDARD_TRANSITION,
} from '../../../styles/constants';
import { Link } from '../../Link';

export const LinkSectionView = styled.div`
  background-color: ${ThemeColours.mono100};
  ${PAGE_CONTAINER};
`;

export const BottomSection = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 70px;
  padding-top: 12px;
  width: 100%;

  ${Breakpoint.SMALL} {
    padding-bottom: 32px;
  }
`;

export const LinkColumns = styled.div`
  display: flex;
  flex-direction: column;

  ${Breakpoint.SMALL} {
    border-bottom: solid 1px ${ThemeColours.mono300};
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 12px;
    padding-bottom: 32px;
  }
`;

export const Group = styled.div`
  border-bottom: solid 1px ${ThemeColours.mono300};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: 12px;
  padding-bottom: 36px;
  padding-top: 24px;

  ${Breakpoint.SMALL} {
    border-bottom: none;
    margin-bottom: 0;
    margin-right: 36px;
    padding-bottom: 0;
    width: 192px;
  }
`;

export const Heading = styled.div`
  color: ${ThemeColours.mono900};
  font-size: 16px;
  font-weight: ${FontWeight.SEMI_BOLD};
  margin-bottom: 4px;
`;

export const LinkItem = styled(Link).attrs({ trackingId: LinkId.FOOTER })`
  ${STANDARD_TRANSITION};
  color: ${ThemeColours.mono900};
  display: block;
  font-size: ${FontSize.SMALL};
  line-height: ${LineHeight.HEADING_3};
  margin: 0;
  text-decoration: none;
  width: fit-content;

  &:hover {
    color: ${ThemeColours.mono800};
    text-decoration: underline;
  }

  ${PRESSABLE_LINK}
`;
